import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import { ChangeEvent, FC } from 'react';
import MaterialTextField from 'src/components/material/textField';
import styles from './CommonField.module.scss';

interface CommonFieldProps {
  title?: string;
  description?: string;
  anchor?: string;
  placeholder?: string;
  charactersLength?: number;
  type?: 'textarea' | 'input';
  value: string;
  setValue: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}

export const CommonField: FC<CommonFieldProps> = ({
  title,
  description,
  anchor,
  placeholder,
  charactersLength = 100,
  type = 'input',
  value,
  setValue,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <div className={styles.title}>{title}</div>
        {/* <div>
          <a
            href={`/how-it-works#${anchor}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <InfoOutlinedIcon style={{ color: 'red', cursor: 'pointer' }} />
          </a>
        </div> */}
      </div>
      <div className={styles.description}>{description}</div>
      <div>
        {type === 'textarea' ? (
          <TextareaAutosize
            className={styles.textarea}
            minRows={2}
            placeholder={placeholder}
            value={value}
            maxLength={charactersLength}
            onChange={setValue}
          />
        ) : (
          <MaterialTextField
            variant="outlined"
            color="primary"
            placeholder={placeholder}
            value={value}
            maxLength={charactersLength}
            onChange={setValue}
          />
        )}
      </div>
      <div className={styles.charactersLength}>
        {value.length}/{charactersLength}
      </div>
    </div>
  );
};
